// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../config/ads';
import { buildPostAdModel } from '../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    WP_PAGE_LOADING() {
      return {
        isLoading: true,
        wpPage: action.wpPage
      };
    },
    WP_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(adsConfig, site, 'page', 'wpPage');

      return {
        isLoading: false,
        data: action.wpPage,
        ads: adModelData
      };
    },
    WP_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.wpPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
